import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: 'Open Sans, Arial, sans-serif',
        h3: {
            fontFamily: 'Poppins, Arial, sans-serif',
            fontWeight: 600,
            color: '#4B4B4B'
        },
        h4: {
            fontFamily: 'Poppins, Arial, sans-serif',
            fontWeight: 700,
            color: '#4B4B4B'
        },
        h5: {
            fontFamily: 'Open Sans, Arial, sans-serif',
            fontSize: '18px',
            fontWeight: 500,
            color: '#4B4B4B'
        },
        h6: {
            fontFamily: 'Open Sans, Arial, sans-serif',
            fontWeight: 500,
            fontSize: '17px',
            color: '#4B4B4B'
        },
        h7: {
            fontFamily: 'Open Sans, Arial, sans-serif',
            fontWeight: 500,
            color: '#4B4B4B'
        },
        body1: {
            fontFamily: 'Open Sans, Arial, sans-serif',
            fontWeight: 400,
            color: '#4B4B4B'
        },
        body2: {
            fontFamily: 'Open Sans, Arial, sans-serif',
            fontWeight: 400,
            color: '#444444'
        },
    },
    palette: {
        primary: {
            main: '#5A5A5A', // soft gray/taupe
        },
        secondary: {
            main: '#F5F5F5', // light beige/cream
        },
        background: {
            default: '#FFFFFF', // white background
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#978A7D',
                    color: '#FFF',
                    borderRadius: '80px',
                    '&:hover': {
                        backgroundColor: '#444444', // Darker gray on hover
                    },
                },
            },
        },
    },
});

export default theme;
